import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/CodeBookItemsPrice/CodeBookItemsPrice.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/loader/Loader';
import { useTranslation } from '../../../context/translationContext';
import { CodeBookItemsPriceForm } from '../../../forms/CodeBookItemsPrice/CodeBookItemsPriceForm';
import { paths } from '../../RouterContainer';
import { CodeBookItemPrice } from '../../../types/CodeBookItemPrice';
import { dateSubmitFormat } from '../../../types/core/date.types';
import { format } from 'date-fns';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for editing existing code book items of company
 */
export const CodeBookItemsPriceUpdatePage = () => {
  const { id, itemId } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState<CodeBookItemPrice | null>(null);
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  useEffect(() => {
    setBreadcrumbs([
      { path: paths.CODE_BOOK_ITEMS, name: 'navigation.code-book-items' },
      {
        path: `${paths.CODE_BOOK_ITEMS}/edit/${itemId}`,
        name: 'navigation.code-book-item-edit',
      },
      {
        path: `${paths.CODE_BOOK_ITEMS}/${itemId}/${paths.CODE_BOOK_ITEMS_PRICE}/edit/${id}`,
        name: 'navigation.code-book-item-price-edit',
      },
    ]);
  }, []);

  /**
   * Loads company code book item
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.CODE_BOOK_ITEM_PRICE_ITEM}?id=${id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles edit action for code book item form submit.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({ url: apiUrl.CODE_BOOK_ITEM_PRICE_UPDATE, data: values });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
        navigate(`/${paths.CODE_BOOK_ITEMS}/edit/${response.data?.codeBookItemId}`);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (data === null) return <Loader />;
  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.code-book-item-price.headline-edit')}</h1>
      <CodeBookItemsPriceForm
        onSubmit={handleSubmit}
        initialValues={
          {
            ...data,
            vatCodeId: data?.vatCode?.id,
            validFrom: format(new Date(data.validFrom), dateSubmitFormat),
          } as Values
        }
      />
    </div>
  );
};
